module.exports = __webpack_public_path__ + "static/copilot-b86e10f41b6c2722ea412b3487de7d4b.webp";